export enum Namespaces {
  BD = 'bd',
  GS = 'gs',
  FAQ = 'fq',
  CC = 'cc',
  QF = 'qf',
  QS = 'qs',
  GP = 'gp',
  OS = 'os',
  PC = 'pc',
  VC = 'vc',
  VP = 'vp',
  RP = 'rp',
  SS = 'ss',
  CW = 'cw',
  US = 'us',
  EP = 'ep',
  SA = 'sa',
  MC = 'mc',
}
